import { ApartmentTypeService } from './../api/apartment-type.service';
import { AgencyService } from './../api/agency.service';
import { Component, OnInit, Injector, Inject, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApartmentType } from './../models/index';
import { Lightbox, LightboxConfig, LightboxEvent, LIGHTBOX_EVENT, IAlbum } from 'angular2-lightbox';
import { Subscription } from 'rxjs/Subscription';
import { Image } from '../models/index';
import { DOCUMENT } from '@angular/platform-browser';
import { BaseComponent } from './base-component';
import { GoogleMapComponent } from '../gmaps/google-map/google-map.component';
import { FbqService } from '../analytics/fbq.service';

@Component({
  selector: 'app-apartment-type-details-base',
  template: ''
})
export class ApartmentTypeDetailsBaseComponent extends BaseComponent implements OnInit {
  @ViewChild(GoogleMapComponent) googleMap: GoogleMapComponent;
  apartmentType: ApartmentType;
  fbqService: FbqService;
  public item: any;
  private _albums: IAlbum[];
  private _subscription: Subscription;

  constructor(
    injector: Injector,
    public route: ActivatedRoute,
    public agencyService: AgencyService,
    public apartmentTypeService: ApartmentTypeService,
    private _lightbox: Lightbox,
    private _lightboxEvent: LightboxEvent,
    private _lighboxConfig: LightboxConfig,
    @Inject('WINDOW') public window: any,
    @Inject(DOCUMENT) public document: any
  ) {
    super(injector);
    this.fbqService = injector.get(FbqService);
  }

  notifyFb(): void {
    this.fbqService.sendEvent(
      'ViewContent',
      {
        content_name: 'ApartmentType',
        content_id: [this.apartmentType.type_name]
      }
    );
  }

  ngOnInit(): void {
    this.route.data.forEach((data: { apartment_type: ApartmentType }) => {
      if (data.apartment_type) {
        this.validateRouteDataParams(data, ['apartment_type']);
        this.apartmentType = data.apartment_type;

        this.item = data.apartment_type;
        this.item.latitude = this.agencyService.agency.latitude;
        this.item.longitude = this.agencyService.agency.longitude;

        this.initLightbox(this.apartmentType.images);

        this.setTitle(this.apartmentType.title);
        this.setMetaDescription(this.apartmentType.description);

        this.notifyFb();
      }
    });
  }

  open(index: number): void {
    if (this.window) {
      this._lighboxConfig.positionFromTop = 20;
    }
    this._subscription = this._lightboxEvent.lightboxEvent$.subscribe(event => this._onReceivedEvent(event));
    this._lightbox.open(this._albums, index, { wrapAround: true, showImageNumberLabel: true });
  }

  private _onReceivedEvent(event: any): void {
    if (event.id === LIGHTBOX_EVENT.CLOSE) {

      if (this._subscription) {
        this._subscription.unsubscribe();
      }
    }
  }

  initLightbox(images: Image[]): void {
    this._albums = [];

    for (const image of images) {
      const album = {
          src: image.url,
          caption: image.description,
          thumb: image.width_560_url
      };

      this._albums.push(album);
    }

    this._lighboxConfig.fadeDuration = 1;
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/apartment-type-details-base.component.ts